import React, { useState } from 'react';

// utils
import chartsUtils, { DataCode } from 'utils/charts.utils';

// styles
import './chartFilter.scss';

interface ChartFilterProps {
    label: string;
    options: Array<DataCode>;
    value: DataCode;
    onClick: (value: DataCode) => void;
}

const ChartFilter = (props: ChartFilterProps) => {
    const handleFilterClick = (value: DataCode) => {
        props.onClick(value);
    };

    return (
        <div className={`chartfilter`}>
            <div>
                <label className="chartfilter-label">{props.label}&nbsp;</label>
            </div>
            <div className="chartfilter-options-container">
                <div className="chartfilter-options-wrapper">
                    <div className={`chartfilter-options`}>
                        <ul>
                            {props.options.map((option) => (
                                <li key={option} className={props.value === option ? 'd-md-inline-block' : ''}>
                                    <button
                                        className={`chartfilter-option-btn ${props.value === option ? 'active' : ''}`}
                                        onClick={() => handleFilterClick(option)}
                                    >
                                        {chartsUtils.getDataCodeName(option)}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChartFilter;
